import React from "react";
import MigrationOptions from "./MigrationOptions";
import RendererPreview from "./RendererPreview";
import styles from "./DevTools.module.css";

/**
 * Content for the General tab in DevTools panel.
 * Contains renderer preview, migration options, and debug actions.
 * @param {Object} props
 * @param {Function} props.onHidePanel - Handler to hide the DevTools panel
 * @param {Function} props.onDebugJSON - Handler to open JSON debug editor
 * @param {Function} props.onCopyPageID - Handler to copy current page ID
 * @param {Function} props.onToggleStageSelectLayer - Handler to toggle stage select layer
 */
const GeneralTabContent = ({
  onHidePanel,
  onDebugJSON,
  onCopyPageID,
  onToggleStageSelectLayer,
}) => (
  <>
    <RendererPreview onHidePanel={onHidePanel} />
    <MigrationOptions />
    <div className={styles.buttonGroup}>
      <button
        type="button"
        className="si-c-btn si-c-btn--primary"
        onClick={onDebugJSON}
      >
        Debug JSON
      </button>
      <button
        type="button"
        className="si-c-btn si-c-btn--primary"
        onClick={onCopyPageID}
      >
        Copy Page ID
      </button>
      <button
        type="button"
        className="si-c-btn si-c-btn--primary"
        onClick={onToggleStageSelectLayer}
      >
        Toggle Stage Select Layer
      </button>
    </div>
  </>
);

export default GeneralTabContent;
